import { Vue, Component, Prop } from 'vue-property-decorator';
import axios from 'axios';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import baseAPIService from '@/services/base/baseAPIService';
import { Functions } from '@/library/utils/functions';
import { appEnvConfig } from '@/configs/appConfigs';
import { EmpServiceAPIActions } from '@/services/empService';

@DialogFactory
@Component({
  components: {},
  mixins: [style],
})
export default class SizeMappingUpload extends IPSDialog {
  fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  corpId = baseAPIService.resolveCorpId();

  title = '上传尺码对照表';

  width = '600px';

  tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  fileName = '';

  // 导入的文件
  importFile: any = {};

  // 文件限制大小 0 不限制
  maxSize = 0;

  isSocketReady = false;

  failNum = 0;

  // 失败数据文件下载地址
  failFileURL = '';

  /**
   * 导入状态 1 导入中 2 导入成功 3 导入失败
   * @type {number}
   */
  importState = 0;

  sizeConfig = [];

  sendToId = `${appEnvConfig.NODE_ENV}export${Date.now()}`;

  gsmId = 0;

  cancelText = '关闭';

  confirm = false;

  contrastName = '';

  originName = '';

  mounted() {
    this.closeSockets();
    this.createConnect();
  }

  // 上传之前校验文件
  onBeforeUpload(file: ItemObject): boolean {
    const fileType = file.name.slice(Math.max(0, file.name.lastIndexOf('.') + 1));
    const extension2 = fileType === 'xlsx';
    this.fileName = file.name;
    this.importFile = file;
    let result = true;
    if (!extension2) {
      this.$message({
        message: '上传文件只能是 xls、xlsx、excel格式!',
        type: 'warning',
      });
      result = false;
    }
    if (this.maxSize) {
      const LtSize = file.size / 1024 <= this.maxSize;
      if (!LtSize) {
        this.$message.error(`上传文件大小不能超过${this.maxSize / 1024}M!`);
        result = false;
      }
    }
    return result;
  }

  // 上传成功
  uploaduccess() {
    this.$message.success('文件上传成功');
  }

  // 上传失败
  uploadError() {
    this.$message.error('文件上传失败');
  }

  // 创建socket
  createConnect() {
    setTimeout(() => {
      this.$socket.connect();
      this.onSokectConnect();
    }, 0);
    setTimeout(() => {
      this.isSocketReady = true;
    }, 1500);
  }

  onSokectConnect() {
    this.$socket.emit('login', this.sendToId);
    this.sockets.subscribe('new_msg', (msg) => {
      if (msg) {
        const msgArr = msg.split('|');
        console.log(msgArr);
        //  导入和导出成功
        if (msgArr[0] === 'success') {
          // 导入成功
          if (msgArr[msgArr.length - 2] === '0') {
            this.$message.success('导入成功');
            this.importState = 2;
            this.$emit('result');
          }
        } else {
          this.$message.warning('导入失败');
          this.failNum = Number(msgArr[msgArr.length - 2]) || 0;
          this.importState = 3;
          this.failFileURL = msgArr[3];
        }
      }
    });
  }

  // 关闭socket
  closeSockets() {
    this.sockets && this.sockets.unsubscribe && this.sockets.unsubscribe('new_msg'); // 取消订阅
    this.$socket && this.$socket.disconnect(); // 断开连接
  }

  downloadTemplate() {
    Functions.excelMaker({
      columns: [
        { header: this.originName, key: 'size', width: 30 },
        { header: this.contrastName, key: 'newSize', width: 30 },
      ],
      data: this.sizeConfig,
      name: '模板',
    });
  }

  downloadExample() {
    Functions.excelMaker({
      columns: [
        { header: '男US', key: 'newSize', width: 30 },
        { header: 'EUR', key: 'size', width: 30 },
      ],
      data: [{ size: '2.5', newSize: '34.5' }],
      name: '示例',
    });
  }

  onImport() {
    this.importState = 1;
    const fileFormData = new FormData();
    fileFormData.append('sendToId', this.sendToId);
    fileFormData.append('gsmId', `${this.gsmId}`);
    fileFormData.append('file', this.importFile, this.fileName);
    fileFormData.append('corpId', this.corpId);
    axios({
      url: `${Functions.ipsHostUrlApi()}/admin/size/post` + `?corpId=${this.corpId}`,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': this.tokenData.Authorization,
      },
      data: fileFormData,
    })
      .then()
      .catch((err) => {
        this.importState = 0;
        console.log(err);
      });
  }

  renderContent(h) {
    return (
      <div class="r-px-24 r-py-12">
        <div class="r-mb-12">
          <el-button type="primary" onClick={this.downloadTemplate.bind(this)}>
            下载模板
          </el-button>
          <span class="scopeSpan r-ml-20" onClick={this.downloadExample.bind(this)}>
            查看范例
          </span>
        </div>
        <div class="flex">
          <el-input placeholder="请选择文件" value={this.fileName} disabled={true} style="width: 80%">
            <template slot="append">
              <el-upload
                action={this.fileTpConfig}
                multiple={false}
                headers={this.tokenData}
                before-upload={this.onBeforeUpload}
                on-success={this.uploaduccess}
                on-error={this.uploadError}
                show-file-list={false}
                data={{ coprId: this.corpId }}
                accept=".xlsx">
                <el-button size="small" type="primary" slot="trigger">
                  选择
                </el-button>
              </el-upload>
            </template>
          </el-input>
          <el-button type="primary" class="r-ml-20 flex1" onClick={this.onImport.bind(this)} disabled={!this.fileName}>
            导入
          </el-button>
        </div>
      </div>
    );
  }
}
